// Warning shown before a run starts: the maintenance snapshot only captures tools
// that are already linked. Tools linked afterwards are never added to it, so this
// is the operator's last chance to link them.
import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'src/components/modal.jsx';

const ToolSnapshotWarningModal = ({ onConfirm, onClose }) => (
  <Modal
    isOpen
    title="Check Linked Tools"
    dismissText="Cancel"
    confirmText="Start Run"
    dataCy="tool-snapshot-warning-modal"
    onConfirm={onConfirm}
    onDismiss={onClose}
  >
    <label className="form-check-label">
      Maintenance is recorded for the tools linked to this run when it starts.
      Tools linked after that are not included. Link any missing tools before you continue.
    </label>
  </Modal>
);

ToolSnapshotWarningModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ToolSnapshotWarningModal;
